import { useJsApiLoader } from '@react-google-maps/api'

const MAPS_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || ''

/**
 * Single source of truth for Google Maps readiness across the dashboard.
 * Returns `keyMissing` (no VITE_GOOGLE_MAPS_API_KEY), `loadError` (Google
 * rejected the key / script failed), and `isLoaded` (safe to touch
 * window.google). A shared loader `id` avoids the "Loader must not be called
 * again with different options" error when multiple maps mount.
 */
export function useMapsReady() {
  const keyMissing = !MAPS_KEY
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'rapidry-google-maps',
    googleMapsApiKey: MAPS_KEY,
  })
  return {
    keyMissing,
    loadError,
    // Only "loaded" when there is actually a key - an empty key leaves
    // isLoaded false forever, which would otherwise hang the UI.
    isLoaded: isLoaded && !keyMissing,
  }
}
